// extracted by mini-css-extract-plugin
module.exports = {"main":"Coating_main__2mvwZ","imgContainer":"Coating_imgContainer__u3qGK","inputs":"Coating_inputs__3lluD"};